import { render, staticRenderFns } from "./CreateAssistant.third.step.vue?vue&type=template&id=fb370c50&scoped=true&"
import script from "./CreateAssistant.third.step.vue?vue&type=script&lang=js&"
export * from "./CreateAssistant.third.step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb370c50",
  null
  
)

export default component.exports